// Shared Partytown constants + helpers.
//
// Partytown relocates the secondary GTM container off the main thread into a
// web worker. Scripts tagged with `type="text/partytown"` are picked up by the
// Partytown runtime and replayed on the main thread if worker startup times out.

export const PARTYTOWN_SCRIPT_TYPE = 'text/partytown'

// Fixed configuration for the secondary GTM container, booted via Partytown from _document.
// This is NOT remotely configured via a Statsig dynamic config — it's a hard-coded
// contract so the worker container id can never be mistyped in the console. `PARTYTOWN_FORWARD`
// relays main-thread `dataLayer.push` calls into the worker with `preserveBehavior: true`, so the
// existing main-thread GTM, TrustArc, and any data-layer proxy keep seeing every push — Partytown
// only sends a copy into the worker.
export const PARTYTOWN_GTM_CONTAINER_ID = 'GTM-K2ZKHX64'
export const PARTYTOWN_FALLBACK_TIMEOUT_MS = 10000
export const PARTYTOWN_FORWARD = [['dataLayer.push', { preserveBehavior: true }]] as const

// Partytown's vendored service worker (`node_modules/@qwik.dev/partytown/lib/debug/partytown-sw.js`)
// assigns `self.onactivate = () => self.clients.claim()` via the `on*` property, not
// `addEventListener('activate', e => e.waitUntil(...))` — so the SW's 'activate' lifecycle does NOT
// wait for `clients.claim()` to settle. `registration.active`/`state==='activated'` can therefore be
// observable before the browser has finished routing fetches for the `/~partytown/` scope to this
// worker. Our loader settles for this bounded delay after detecting activation before calling
// `boot()` (which creates the sandbox iframe), instead of booting the instant activation is
// observed. Negligible against the 3s activation-wait / 10s fallback budgets either side of it.
export const PARTYTOWN_SW_ACTIVATION_SETTLE_MS = 150

// Partytown's service worker. The loader registers it itself, but we also
// pre-register it from an inline script in _document <head> so that on cold
// first visits the SW is active well before the loader creates the sandbox
// iframe. `partytown-sandbox-sw.html` is a VIRTUAL url synthesized by this
// SW's fetch handler — if the iframe request races SW activation and reaches
// the network it 404s and the sandbox never boots (silent worker-container loss).
export const PARTYTOWN_SW_URL = '/~partytown/partytown-sw.js'
export const PARTYTOWN_SW_SCOPE = '/~partytown/'
